export default "__VITE_ASSET__jmecV0mM__";